import gql from 'graphql-tag';

export const GET_INDIVIDUAL_EDITING_COMPANY_EDITORS = gql`
	query GetIndividualEditingCompanyEditors($query: JSON!) {
		users(query: $query) {
			id
			image
			name
			email
			certificates
		}
	}
`;
